import { Budget, Transaction } from '../types/budget';
import Papa from 'papaparse';

/**
 * Formats a date as DD/MM/YYYY
 */
const formatDate = (date: Date): string => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

// Note: currency formatting is handled in UI; exports keep raw numbers

/**
 * Exports a budget to a CSV file using PapaParse
 */
export const exportBudgetToCSV = (budget: Budget): void => {
  // Convert transactions to an array of objects with the fields we want to export
  const data = budget.transactions.map((transaction: Transaction) => ({
    category: transaction.category,
    responsible: transaction.responsible,
    description: transaction.description,
    destination: transaction.destination,
    amount: transaction.amount,
    date: formatDate(budget.date),
  }));

  // Use PapaParse to generate CSV
  const csv = Papa.unparse(data, {
    header: true,
    newline: '\n',
  });

  // Create a Blob with the CSV data
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  // Create a link element to trigger the download
  const link = document.createElement('a');
  const filename = `budget_${budget.name}_${formatDate(budget.date)}.csv`;

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
